import { useSubscriptionEventHelper } from '../subscriptionEventHelper';
import { useShowContextRequired } from 'ui-builder';
import { WebhookSubscription } from 'nekst-api';

export function EventTypeField() {
  const typeHelper = useSubscriptionEventHelper();
  const { data } = useShowContextRequired<WebhookSubscription>();

  return typeHelper.getLabel(data.eventType);
}

